/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PasswordChangeVO } from '../model';
// @ts-ignore
import { QrVO } from '../model';
// @ts-ignore
import { ScInfoResponseVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ParovaniControllerApi - axios parameter creator
 * @export
 */
export const ParovaniControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQr: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/parovani/qr/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: async (body?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/parovani/setting/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PasswordChangeVO} [passwordChangeVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChange: async (passwordChangeVO?: PasswordChangeVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/parovani/password-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChangeVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrDownload: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/parovani/qr/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrShow: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/parovani/qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParovaniControllerApi - functional programming interface
 * @export
 */
export const ParovaniControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParovaniControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQr(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getQr(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info(body?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScInfoResponseVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.info(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PasswordChangeVO} [passwordChangeVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordChange(passwordChangeVO?: PasswordChangeVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.passwordChange(passwordChangeVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrDownload(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.qrDownload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrShow(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.qrShow(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ParovaniControllerApi - factory interface
 * @export
 */
export const ParovaniControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParovaniControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQr(options?: any): AxiosPromise<QrVO> {
            return localVarFp.getQr(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(body?: string, options?: any): AxiosPromise<ScInfoResponseVO> {
            return localVarFp.info(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PasswordChangeVO} [passwordChangeVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordChange(passwordChangeVO?: PasswordChangeVO, options?: any): AxiosPromise<void> {
            return localVarFp.passwordChange(passwordChangeVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrDownload(options?: any): AxiosPromise<void> {
            return localVarFp.qrDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrShow(options?: any): AxiosPromise<void> {
            return localVarFp.qrShow(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParovaniControllerApi - interface
 * @export
 * @interface ParovaniControllerApi
 */
export interface ParovaniControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApiInterface
     */
    getQr(options?: any): AxiosPromise<QrVO>;

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApiInterface
     */
    info(body?: string, options?: any): AxiosPromise<ScInfoResponseVO>;

    /**
     * 
     * @param {PasswordChangeVO} [passwordChangeVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApiInterface
     */
    passwordChange(passwordChangeVO?: PasswordChangeVO, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApiInterface
     */
    qrDownload(options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApiInterface
     */
    qrShow(options?: any): AxiosPromise<void>;

}

/**
 * ParovaniControllerApi - object-oriented interface
 * @export
 * @class ParovaniControllerApi
 * @extends {BaseAPI}
 */
export class ParovaniControllerApi extends BaseAPI implements ParovaniControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApi
     */
    public getQr(options?: any) {
        return ParovaniControllerApiFp(this.configuration).getQr(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApi
     */
    public info(body?: string, options?: any) {
        return ParovaniControllerApiFp(this.configuration).info(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PasswordChangeVO} [passwordChangeVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApi
     */
    public passwordChange(passwordChangeVO?: PasswordChangeVO, options?: any) {
        return ParovaniControllerApiFp(this.configuration).passwordChange(passwordChangeVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApi
     */
    public qrDownload(options?: any) {
        return ParovaniControllerApiFp(this.configuration).qrDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParovaniControllerApi
     */
    public qrShow(options?: any) {
        return ParovaniControllerApiFp(this.configuration).qrShow(options).then((request) => request(this.axios, this.basePath));
    }
}
